export const name = 'editorNavigation' as const
export const EditorNavigationSymbol = Symbol('editorNavigationSymbol')
export const IsDuringNavigationInteractionSymbol = Symbol('isDuringNavigationInteractionSymbol')
